import { HFBox, HFButton, HFCard, useHFAlert } from '@hf/designSystem/v1';
import { GA, track } from '@core/utils/analytics';
import { WorkflowDemo } from '../landing/WorkflowDemo';

/**
 * Non-subscriber Tearsheets landing (#14395).
 * Shown when `tearsheets` is on and `tearsheets/is_subscriber` is off.
 * Subscribe CTA plus mock-only animated tour. No product APIs.
 */
export function TearsheetsLandingPage() {
  const { push } = useHFAlert();

  function subscribe() {
    track(GA.openedWorkspace, { item_id: '/tearsheets/subscribe' });
    push({ severity: 'info', message: 'Subscription checkout is coming soon.' });
  }

  return (
    <HFBox
      sx={{
        mx: 'auto',
        width: '100%',
        maxWidth: 1360,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <HFCard density="compact">
        <HFBox
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
          }}
        >
          <HFBox sx={{ minWidth: 0, flex: '1 1 auto', display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <HFBox
              component="p"
              sx={{ m: 0, mb: 0.5, fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: 'primary.main' }}
            >
              HedgeFacts Web Tearsheets
            </HFBox>
            <HFBox
              component="h1"
              sx={{ m: 0, fontSize: { xs: '1.2rem', md: '1.45rem' }, fontWeight: 800, letterSpacing: '-0.02em', lineHeight: 1.25 }}
            >
              Tearsheets for every reporting month
            </HFBox>
            <HFBox component="p" sx={{ m: 0, color: 'text.secondary', fontSize: '0.9rem', lineHeight: 1.45 }}>
              Layouts, branding, review workflow, and PDF export. Subscribe to use Tearsheets on your funds.
            </HFBox>
          </HFBox>
          <HFBox sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'stretch', sm: 'flex-end' }, gap: 0.75, flex: '0 0 auto' }}>
            <HFButton color="primary" onClick={subscribe} sx={{ px: 3.5, whiteSpace: 'nowrap' }}>
              Subscribe
            </HFButton>
            <HFBox component="p" sx={{ m: 0, fontSize: '0.75rem', color: 'text.secondary', textAlign: { xs: 'left', sm: 'right' } }}>
              Demo uses sample data
            </HFBox>
          </HFBox>
        </HFBox>
      </HFCard>

      <HFBox id="tearsheets-workflow-demo">
        <WorkflowDemo />
      </HFBox>
    </HFBox>
  );
}
